import loadable from '@loadable/component';

export const ViewUserProfilePageNotFoundLoadable = loadable(
  () => import('./ViewUserProfilePageNotFound'),
  { resolveComponent: (module) => module.ViewUserProfilePageNotFound },
);
